import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';

const action = (
  state: IState,
  payloadAction: PayloadAction<{ folderId: number; name: string }>,
) => {
  const { folderId, name } = payloadAction.payload;

  state.catalogs.data = {
    ...state.catalogs.data,
    [folderId]: {
      ...state.catalogs.data[folderId],
      name,
    },
  };
};

export default action;
